export interface IGetDevicesPositionsOutputDto {
    deviceId: string;
    externalId?: string;
    identification?: { type: string; value: string };
    maxSpeed: number;
    route: IPositions[];
    trip?: IDeviceWithRouteTrip;
}

interface IDeviceWithRouteTrip {
    code: string;
}

export interface IPositions {
    latitude: string;
    longitude: string;
    timestamp: string;
    bearing?: number;
    speed: number;
}
